const session = {
    // 读取sessionStorage
    get: key => {
        if (typeof key !== 'string') {
            console.error('键必须是字符串。');
            return null;
        }
        try {
            const item = window.sessionStorage.getItem(key);
            return item ? JSON.parse(item) : null;
        } catch (err) {
            console.error('从 sessionStorage 解析 JSON 时出错：', err);
            return window.sessionStorage.getItem(key);
        }
    },
    // 创建sessionStorage
    set: (key, value) => {
        if (typeof key !== 'string') {
            console.error('键必须是字符串。');
            return;
        }
        if (value === undefined) {
            console.error('值不能为空。');
            return;
        }
        try {
            window.sessionStorage.setItem(key, JSON.stringify(value));
        } catch (err) {
            console.error('将值序列化为 JSON 时出错：', err);
        }
    },
    // 移除指定sessionStorage
    remove: key => {
        if (typeof key !== 'string') {
            console.error('键必须是字符串。');
            return;
        }
        window.sessionStorage.removeItem(key);
    },
    // 清除sessionStorage
    clear: () => {
        window.sessionStorage.clear();
    }
}

const local = {
    // 读取localStorage
    get: key => {
        if (typeof key !== 'string') {
            console.error('键必须是字符串。');
            return null;
        }
        try {
            const item = JSON.parse(window.localStorage.getItem(key));
            if (!item) return null;

            // 判断是否过期
            if (item.time === -1) { //-1直接返回
                return item.value;
            }

            const currentTime = new Date().getTime();
            if (item.time > 0 && currentTime > item.expiryTime) {
                local.remove(key);
                return null;
            }
            return item.value;
        } catch (err) {
            console.error('从 localStorage 解析 JSON 时出错：', err);
            return null;
        }
    },
    // 创建localStorage
    set: (key, value, time = -1) => {
        if (typeof key !== 'string') {
            console.error('键必须是字符串。');
            return;
        }
        if (value === undefined) {
            console.error('值不能为空。');
            return;
        }
        try {
            const currentTime = new Date().getTime();
            const expiryTime = time === -1 ? -1 : currentTime + time * 1000;

            const setItem = {
                time,
                value,
                expiryTime
            }
            window.localStorage.setItem(key, JSON.stringify(setItem));
        } catch (err) {
            console.error('将值序列化为 JSON 时出错：', err);
        }
    },
    // 移除指定localStorage
    remove: key => {
        if (typeof key !== 'string') {
            console.error('键必须是字符串。');
            return;
        }
        window.localStorage.removeItem(key);
    },
    // 清除localStorage
    clear: () => {
        window.localStorage.clear();
    }
}

export {session, local}
